import React, {createElement, useEffect, useRef, useState} from 'react';
import Style from './index.module.scss';
import { Mask } from '@ifeng/lowcode_tool/src/components/Mask'
import { useChip, TYPE_Chip } from '@ifeng/lowcode_tool/src/hooks/useChip'
import { formatChip } from '@ifeng/lowcode_tool/src/method/chip'
import Player from '@ifeng/three_terminal/es/pc/video/output/pcVideo.jsx';
import Chip from 'Chip';

export interface Image_Tabs_Props {
    style?: object;

    imagesChip: TYPE_Chip
    contentHeight: number
}

const Image_Tabs: React.FC<Image_Tabs_Props> = (props) => {
    const { style, imagesChip, contentHeight } = props;

    const [ tabIndex, setTabIndex ] = useState(0)

    const contentRef = useRef()

    const imagesChipData = useChip(imagesChip)
    const imagesChipComponentData = formatChip(imagesChip)

    const handleTab = (index) => {
        setTabIndex(index)
        contentRef.current.scrollTop = 0
    }

    return (
        <Chip {...imagesChipComponentData}>
            <div className={Style.wrap} style={style}>
                <ul class={Style.tabs}>
                    {
                        imagesChipData.map((images, index) => {
                            return <li className={tabIndex === index ? Style.current : ''} onClick={() => handleTab(index)} key={index}>{images.title}</li>
                        })
                    }
                </ul>
                <div ref={contentRef} className={Style.content} style={{ height: `${contentHeight}px`}}>
                    {
                        imagesChipData[tabIndex]?.imageList && imagesChipData[tabIndex].imageList.map((image, index) => {
                            return <img src={image} key={index} alt="" />
                        })
                    }
                </div>
                <Mask visible={!imagesChip.id} zIndex={3}>
                    示例结构化碎片—{imagesChip.default.id}
                </Mask>
            </div>
        </Chip>

    );
};

export default Image_Tabs;
